import * as StorageUtils from './storage';

const AUTH_KEY = btoa('AUTH_DATA');

export const storeAuth = async (data) => {
  await StorageUtils.saveStore(data, AUTH_KEY);
};

export const getAuth = async () => {
  const jsonData = await StorageUtils.getStore(AUTH_KEY);
  return jsonData;
};

export const removeAuth = async () => {
  await StorageUtils.removeStore(AUTH_KEY);
};

export const getItem = async (key) => {
  try {
    const auth = await getAuth();
    return auth[key];
  }

  catch {
    return undefined;
  }
};

export const getToken = async () => {
  const token = await getItem('token');
  return token;
};

export const getProfile = async () => {
  const profile = await getItem('profile');
  return profile;
};

export const getHostname = async () => {
  const hostname = await getItem('hostname');
  return hostname;
};

export const getFlow = async () => {
  const flow = await getItem('flow');
  return flow;
};

export const getStep = async () => {
  const step = await getItem('step');
  return step;
};

export const getCardConfig = async () => {
  const cardConfig = await getItem('cardConfig');
  return cardConfig;
};

export const getProcess = async () => {
  const process = await getItem('process');
  return process;
};

export const getFlowProcess = async () => {
  const flowProcess = await getItem('flowProcess');
  return flowProcess;
};

export const getCompany = async () => {
  const company = await getItem('company');
  return company;
};

export const getStatus = async () => {
  const company = await getItem('status');
  return company;
};

export const getEmail = async () => {
  const email = await getItem('email');
  return email;
};

export const getName = async () => {
  const name = await getItem('name');
  return name;
};

export const getStepConfig = async () => {
  const stepConfigId = await getItem('stepConfigId');
  return stepConfigId;
};

export const getlivenessNode = async () => {
  const livenessNode = await getItem('livenessNode');
  return livenessNode;
};
